/**
 * Shared types + helpers for the M16-Report (Geo Intelligence) admin screens.
 * All calls hit the backend `v1/geo-intel/*` API through apiRequest (which
 * prepends /api).
 */

export interface MapConfig {
  provider: 'GOOGLE' | 'OSM' | 'LEAFLET' | 'MAPBOX';
  configuredProvider: string;
  googleMapsApiKey: string;
  mapboxAccessToken: string;
  usingFreeFallback: boolean;
  defaultCenter: { lat: number; lng: number };
  defaultZoom: number;
}

/** What the activity map's checkboxes and filters hold. */
export interface ActivityFilterState {
  stages: string[];
  itemIds: string[];
  vendorIds: string[];
  territoryIds: string[];
  dateFrom: string;
  dateTo: string;
}

/** One activity with a position, at its latest stage (vw_geo_activity_point). */
export interface ActivityPoint {
  activityId: string;
  activitySource: 'JOB_REQUEST' | 'ORDER_LINE';
  reference: string | null;
  brandingItemId: string | null;
  itemName: string | null;
  mapShape: string | null;
  stageCode: string;
  latitude: number;
  longitude: number;
  locationSource: string;
  customerName: string | null;
  vendorName: string | null;
  territoryName: string | null;
  activityDate: string | null;
}

/** Stage colours, activity shapes and the filter lists, from activity-legend. */
export interface ActivityLegend {
  stages: Array<{ stageCode: string; colourHex: string; count: number }>;
  items: Array<{ brandingItemId: string; itemName: string; mapShape: string; count: number }>;
  vendors: Array<{ id: string; name: string }>;
  territories: Array<{ id: string; name: string }>;
}

/** The activities query: comma-separated lists, dates as given. */
export function buildActivityQuery(filter: ActivityFilterState): string {
  const p = new URLSearchParams();
  p.set('stages', filter.stages.join(','));
  p.set('items', filter.itemIds.join(','));
  if (filter.vendorIds.length) p.set('vendorIds', filter.vendorIds.join(','));
  if (filter.territoryIds.length) p.set('territoryIds', filter.territoryIds.join(','));
  if (filter.dateFrom) p.set('dateFrom', filter.dateFrom);
  if (filter.dateTo) p.set('dateTo', filter.dateTo);
  return `?${p.toString()}`;
}
